import React from 'react';
import { MentorShape } from 'utils/shapes';
import reverseUrl from 'utils/urls';
import Preview from '../Preview';

const SingleMentor = ({ mentor }) =>
    Preview({
        url: reverseUrl('trafo_member_profile', { pk: mentor.user.id }),
        title: mentor.user.name,
        subtitle: mentor.cat.map((cat, index) => {
            if (index === mentor.cat.length - 1) {
                return <span key={cat.id}>{cat.name}</span>;
            } else {
                return <span key={cat.id}>{cat.name}, </span>;
            }
        }),
        description: mentor.info,
        image: mentor.user.avatar_url_medium,
    });

SingleMentor.propTypes = {
    mentor: MentorShape.isRequired,
};

export default SingleMentor;



// WEBPACK FOOTER //
// ./src/components/mentors/SingleMentor.js